import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import { useBnsGuangGaoFaBuDelMutation, useBnsGuangGaoFaBuListQuery } from '../../store/ReactWebSiteApi';
import ModalDel from '../../cpn/ModalDel';
import PublishCheck from './PublishCheck';
import PublishEdit from './PublishEdit';
import PublishAdd from './PublishAdd';
import PublishState from './PublishState';
function PublishList() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsGuangGaoFaBuListQuery();    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bggfb_id:key,bggfb_name,bggfb_ctime,bggfb_cname,bggfb_content,bggfb_dept_id,bggfb_dept_name,bggfb_jihuariqi,bggfb_bg_name,bggfb_meijie_name,bggfb_fuzhuren_name,bggfb_state,bggfb_bbz_name} = item;
                    return item = {key,bggfb_name,bggfb_ctime,bggfb_cname,bggfb_content,bggfb_dept_id,bggfb_dept_name,bggfb_jihuariqi,bggfb_bg_name,bggfb_meijie_name,bggfb_fuzhuren_name,bggfb_state,bggfb_bbz_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bggfb_ctime;
                    let bTimeString = b.bggfb_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'bggfb_meijie_name',
            title: '媒介',            
            dataIndex: 'bggfb_meijie_name',
        },
        {
            key: 'bggfb_bg_name',
            title: '产品',            
            dataIndex:'bggfb_bg_name'
        },
        {
            key: 'bggfb_bbz_name',
            title: '广告设计',            
            dataIndex:'bggfb_bbz_name'
        },
        {
            key: 'bggfb_jihuariqi',
            title: '日期',            
            dataIndex:'bggfb_jihuariqi'
        },
        {
            key: 'bggfb_fuzhuren_name',
            title: '负责人',            
            dataIndex: 'bggfb_fuzhuren_name',
            
        },
        {
            key: 'list',
            title: '名称',
            render:(_,record) => {
                return  <PublishCheck 
                            bggfb_name={record.bggfb_name}
                            bggfb_id={record.key}
                        />
            }            
        },     
        {
            key: 'bggfb_state',
            title: '状态',
            dataIndex:'bggfb_state',
            render:(text) => {
                if(text==='1'){
                    return<>已实现</>
                }else{
                    return<>待实现</>
                }
            }   
        },     
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            
        },
        {
            key: 'bggfb_dept_name',
            title: '部门',            
            dataIndex: 'bggfb_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bggfb_ctime + record.bggfb_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <PublishEdit
                            bggfb_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bggfb_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} /> 
                        <PublishState
                            bggfb_id={record.key}
                            bggfb_state={record.bggfb_state}
                        />      
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsGuangGaoFaBuDelMutation()
    return (
        <Main t1='推广'  t2='广告发布'>
            <Space size='large'>
                <PublishAdd />             
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default PublishList